import React from 'react'
import {Trans, useTranslation} from 'react-i18next'
import {Card, Typography} from 'antd'
import classNames from 'classnames'
import {useScreenType, useLocalStorageBoolean} from '@/hooks'
import {IS_SIDER_COLLAPSED_KEY} from '@/constants'
import {DigitalReceiptsButtons} from '../'
import BoostCustomerSatisfactionImg from '~/assets/img/digital-receipts/boost_customer_satisfaction.svg'

import styles from './styles.scss'

export const CustomerSatisfaction = () => {
    const {t} = useTranslation()
    const {isTablet, isDesktop, isMobile} = useScreenType()
    const isCollapsed = useLocalStorageBoolean(IS_SIDER_COLLAPSED_KEY)

    const titleLevel = isDesktop ? 1 : 3

    const containerClass = classNames(styles.root, {
        [styles.mobileLayout]: isMobile || (isTablet && !isCollapsed),
        [styles.desktopLayout]: isDesktop || (isTablet && isCollapsed)
    })

    return (
        <Card>
            <div className={containerClass}>
                <div className={styles.content}>
                    <Typography.Title level={titleLevel} className={styles.title}>
                        <Trans
                            i18nKey='CustomerSatisfaction.title'
                            components={{
                                green: <span className={styles.green} />
                            }}
                        />
                    </Typography.Title>
                    <Typography.Paragraph>
                        {t('CustomerSatisfaction.description')}
                    </Typography.Paragraph>
                    <ul className={styles.list}>
                        <li>{t('CustomerSatisfaction.item1')}</li>
                        <li>{t('CustomerSatisfaction.item2')}</li>
                    </ul>

                    <DigitalReceiptsButtons className={styles.buttons} />
                </div>
                <div className={styles.imageContainer}>
                    <img src={BoostCustomerSatisfactionImg} alt={t('CustomerSatisfaction.alt')} />
                </div>
            </div>
        </Card>
    )
}
